import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { getStoreInfo } from "@/api/public.api.js";

const StoreInfoContext = createContext({
    storeInfo: null,
    loading: true,
    error: "",
    refresh: async () => {}
});

export function StoreInfoProvider({ children }) {
    const [storeInfo, setStoreInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const refresh = useCallback(async ({ silent = false } = {}) => {
        if (!silent) {
            setLoading(true);
        }
        setError("");
        try {
            const data = await getStoreInfo();
            setStoreInfo(data);
            return data;
        } catch (err) {
            if (!silent) {
                setStoreInfo(null);
            }
            setError(err?.message || "Impossible de charger les informations du magasin.");
            throw err;
        } finally {
            if (!silent) {
                setLoading(false);
            }
        }
    }, []);

    useEffect(() => {
        refresh().catch(() => {});
    }, [refresh]);

    const value = useMemo(
        () => ({ storeInfo, loading, error, refresh }),
        [storeInfo, loading, error, refresh]
    );

    return (
        <StoreInfoContext.Provider value={value}>
            {children}
        </StoreInfoContext.Provider>
    );
}

export function useStoreInfo() {
    return useContext(StoreInfoContext);
}
